import { useQuery } from '@apollo/client';

import { ADMIN_EVENT_USERS } from '../graphql/query/adminEventUsersQuery.graphql';

export const useAdminEventUsersQuery = (
  eventId: string | null,
  previousEventId: string | null,
) => {
  return useQuery(ADMIN_EVENT_USERS, {
    variables: {
      eventId: eventId ?? '',
      previousEventId,
    },
    skip: !eventId,
  });
};
